"use client";

import { cn } from "../../lib/utils";

export interface ProgressProps {
  value?: number;
  className?: string;
}

export function Progress({ value = 0, className }: ProgressProps) {
  return (
    <div className={cn("w-full h-1.5 rounded-full bg-gray-200", className)}>
      <div
        className="h-1.5 rounded-full bg-primary transition-all"
        style={{ width: `${value}%` }}
      />
    </div>
  );
}
